import { render, staticRenderFns } from "./ProjectPayoutSummary.vue?vue&type=template&id=c54b101e&"
import script from "./ProjectPayoutSummary.vue?vue&type=script&lang=js&"
export * from "./ProjectPayoutSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPayoutSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports